import { useModelCompareTranslation } from "constants/modelCompareData/translations/useModelCompareTranslation";import * as S from "../../../CompareTable.styles";
import type { FootNotesProps } from "./FootNotes.types";

export const FootNotes = ({ products }: FootNotesProps) => {
  const { formatMessage } = useModelCompareTranslation();

  return (
    <>
      <S.EmptyPropertyTitleGridItem stickX />
      {products.map((product, index) => {
        if (!product?.footnotes?.length) {
          return <S.CenterPlaceholderGridItem key={`${product.id}-${index}`} />;
        }

        return (
          <S.FootnotesWrap key={`${product.id}-${index}`}>
            {product.footnotes.map((footnote, i) => (
              <S.Note key={i}>{formatMessage(footnote)}</S.Note>
            ))}
          </S.FootnotesWrap>
        );
      })}
    </>
  );
};
